(() => {
  angular
    .module('finance')
    .controller(
      'finance.views.debugTools.updateNetSuiteTransactionIdsToNullModal',
      UpdateNetSuiteTransactionIdsToNullModalController
    );

  UpdateNetSuiteTransactionIdsToNullModalController.$inject = [
    '$uibModalInstance',
    'abp.services.finance.debugTools',
  ];

  function UpdateNetSuiteTransactionIdsToNullModalController(
    $uibModalInstance, 
    debugToolsSvc
  ) {
    const vm = this;
    
    vm.saving = 0;

    vm.updateNetSuiteTransactionIdsToNull = updateNetSuiteTransactionIdsToNull;
    vm.cancel = cancel;

    function updateNetSuiteTransactionIdsToNull() {
      vm.saving += 1;
      debugToolsSvc
        .updateNetSuiteSaleTransactionIdsToNull({
          maxCount: vm.maxCount,
          chunkSize: vm.chunkSize,
          transactionNumber: vm.transactionNumber
        })
        .success(() => {
          abp.notify.success(App.localize('Success'));
        })
        .finally(() => {
          $uibModalInstance.close();
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
